/**
 * View mode: list — 4 rows, each with a bullet dot + horizontal line.
 * Uses `currentColor`. No internal SVG padding — caller handles spacing.
 */
export function ViewList({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      {/* Row 1 */}
      <circle cx="3.5" cy="4" r="1.5" fill="currentColor" stroke="none" />
      <line x1="8" y1="4" x2="21" y2="4" />
      {/* Row 2 */}
      <circle cx="3.5" cy="9" r="1.5" fill="currentColor" stroke="none" />
      <line x1="8" y1="9" x2="21" y2="9" />
      {/* Row 3 */}
      <circle cx="3.5" cy="14" r="1.5" fill="currentColor" stroke="none" />
      <line x1="8" y1="14" x2="21" y2="14" />
      {/* Row 4 */}
      <circle cx="3.5" cy="19" r="1.5" fill="currentColor" stroke="none" />
      <line x1="8" y1="19" x2="21" y2="19" />
    </svg>
  )
}
